<template>
  <section class="ranking-player-list-item-parts">
    <div class="ranking-player-list-item-parts__content">
      <div class="ranking-player-list-item-parts__rank">
        <i>
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 3.5465V2H4V3.5465H1V5.75C1 7.64375 2.41675 9.1985 4.243 9.449C4.50458 10.2161 4.96855 10.8983 5.58586 11.4234C6.20317 11.9486 6.95089 12.2972 7.75 12.4325V13.25C7.75 13.6478 7.59196 14.0294 7.31066 14.3107C7.02936 14.592 6.64782 14.75 6.25 14.75H5.5V16.25H11.5V14.75H10.75C10.3522 14.75 9.97064 14.592 9.68934 14.3107C9.40804 14.0294 9.25 13.6478 9.25 13.25V12.4325C10.0491 12.2972 10.7968 11.9486 11.4141 11.4234C12.0315 10.8983 12.4954 10.2161 12.757 9.449C14.5833 9.1985 16 7.64375 16 5.75V3.5465H13ZM2.5 5.75V5.0465H4V7.871C3.56162 7.71554 3.18209 7.42822 2.91352 7.04846C2.64495 6.6687 2.5005 6.21513 2.5 5.75ZM14.5 5.75C14.4994 6.21521 14.355 6.66885 14.0864 7.04871C13.8179 7.42857 13.4384 7.71606 13 7.87175V5.0465H14.5V5.75Z"
              :fill="svgColor"
            />
          </svg>
        </i>
        <span>{{ rank }}</span>
      </div>
      <div class="ranking-player-list-item-parts__player">
        <figure class="ranking-player-list-item-parts__img">
          <img v-if="playerData.img" :src="playerData.img" :alt="playerData.name[$i18n.locale]" />
        </figure>
        <div class="ranking-player-list-item-parts__meta">
          <h4 class="ranking-player-list-item-parts__name">
            {{ playerData.number ? `#${playerData.number} ` : null }}
            {{ playerData.name[$i18n.locale] }}
          </h4>
          <p class="ranking-player-list-item-parts__best-data" v-text="playerData.bestData" />
        </div>
      </div>
    </div>
    <div class="ranking-player-list-item-parts__link">
      <ranking-player-link-parts v-if="playerData.links[0]" :linkData="playerData.links[0]" />
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import RankingPlayerLinkParts from '@/components/RaceListPage/RaceListPane/parts/RankingPlayerLinkParts.vue'
import { PlayerRankData } from '@/components/RaceListPage/RaceListPane/parts/RankingCardParts.vue'

/**
 * レース一覧画面: レース ランキング 2位以下プレーヤー情報コンポーネント
 */
export default defineComponent({
  name: 'RankingPlayerListItemParts',
  components: {
    RankingPlayerLinkParts,
  },
  props: {
    rank: {
      type: Number,
      required: true,
    },
    playerData: {
      type: Object as PropType<PlayerRankData>,
      required: true,
    },
  },
  setup(props) {
    const svgColor = props.rank === 2 ? '#c2c2c2' : '#d98b52'
    return {
      svgColor,
    }
  },
})
</script>

<style lang="scss" scoped>
.ranking-player-list-item-parts {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 0;
  gap: min(#{convertPXtoVW(15), 15px});

  &__content {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    width: 100%;
    gap: 5px;
  }

  &__rank {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: min(#{convertPXtoVW(3), 3px});
    font-weight: 600;
    font-size: min(#{convertPXtoVW(20), 20px});
    line-height: 1.2;
    letter-spacing: 0.04em;

    i {
      display: block;
      width: min(#{convertPXtoVW(18), 18px});

      svg {
        display: block;
        width: 100%;
      }
    }
  }

  &__player {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    width: 100%;
    gap: min(#{convertPXtoVW(12), 12px});
  }

  &__img {
    width: min(#{convertPXtoVW(56), 56px});
  }

  &__meta {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    width: calc(100% - min(#{convertPXtoVW(56), 56px}));
    gap: 2px;
    font-weight: 500;
    letter-spacing: 0.04em;
    text-align: left;
  }

  &__name {
    font-size: min(#{convertPXtoVW(12), 12px});
    line-height: 1.33;
  }

  &__best-data {
    font-size: min(#{convertPXtoVW(11), 11px});
    line-height: 1.24;
  }

  &__link {
    width: min(#{convertPXtoVW(58), 58px});

    &--disabled {
      pointer-events: none;
    }
  }
}
</style>

<style lang="scss">
.ranking-player-list-item-parts {
  &__link {
    .atom-icon-router-btn--has-icon {
      padding: 4px min(#{convertPXtoVW(10), 10px});
      min-width: min(#{convertPXtoVW(58), 58px});

      img {
        width: min(#{convertPXtoVW(18)}, 18px);
        margin: 0;
      }
    }
  }
}
</style>
